import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bell, BellRing } from 'lucide-react';
import api from '../lib/api';
import { useToast } from '../hooks/use-toast';

export const SizeStockAlert = ({ productId, sizes }) => {
  const { toast } = useToast();
  const [subscribed, setSubscribed] = useState([]);
  const [busy, setBusy] = useState(null);
  const loggedIn = !!localStorage.getItem('token');
  const soldOut = sizes.filter((s) => !s.available);

  useEffect(() => {
    if (!loggedIn || !soldOut.length) return;
    api.get(`/stock-alerts/product/${productId}`).then((r) => setSubscribed(r.data.stockIds || [])).catch(() => {});
  }, [productId, loggedIn, soldOut.length]);

  if (!soldOut.length) return null;

  const toggle = async (s) => {
    setBusy(s.stockId);
    try {
      if (subscribed.includes(s.stockId)) {
        await api.delete(`/stock-alerts/product/${productId}`, { params: { stockId: s.stockId } });
        setSubscribed((l) => l.filter((x) => x !== s.stockId));
        toast({ title: 'Alertă anulată', description: `Nu te mai anunțăm pentru mărimea ${s.size}.` });
      } else {
        await api.post('/stock-alerts', { productId, stockId: s.stockId, size: s.size });
        setSubscribed((l) => [...l, s.stockId]);
        toast({ title: 'Te anunțăm!', description: `Primești un email când mărimea ${s.size} revine pe stoc.` });
      }
    } catch (e) {
      toast({ title: 'Eroare', description: e.response?.data?.detail || 'Încearcă din nou.', variant: 'destructive' });
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="mt-3 rounded-xl border border-dashed border-gray-300 bg-gray-50 p-3" data-testid="stock-alert-box">
      <p className="flex items-center gap-1.5 text-sm font-medium text-gray-800">
        <Bell className="h-4 w-4 text-green-700" /> Mărimea ta e epuizată? Te anunțăm pe email când revine.
      </p>
      {loggedIn ? (
        <div className="mt-2 flex flex-wrap gap-2">
          {soldOut.map((s) => {
            const on = subscribed.includes(s.stockId);
            return (
              <button key={s.stockId} type="button" disabled={busy === s.stockId} onClick={() => toggle(s)}
                className={`inline-flex items-center gap-1 rounded-lg border px-3 py-1.5 text-xs font-semibold transition-colors ${
                  on ? 'border-green-600 bg-green-600 text-white' : 'border-gray-300 bg-white text-gray-700 hover:border-green-600'}`}
                data-testid={`stock-alert-size-${s.size}`}>
                {on ? <BellRing className="h-3.5 w-3.5" /> : <Bell className="h-3.5 w-3.5" />}
                {s.size}{on ? ' · te anunțăm' : ''}
              </button>
            );
          })}
        </div>
      ) : (
        <p className="mt-1 text-xs text-gray-600">
          <Link to="/login" className="font-semibold text-green-700 hover:underline" data-testid="stock-alert-login">Intră în cont</Link>
          {' '}ca să primești alerta.
        </p>
      )}
    </div>
  );
};
